import { render } from "./order-box.vue?vue&type=template&id=60fb9093&scoped=true"
import script from "./order-box.vue?vue&type=script&lang=js"
export * from "./order-box.vue?vue&type=script&lang=js"

import "./order-box.vue?vue&type=style&index=0&id=60fb9093&lang=less&scoped=true"

import exportComponent from "/Users/wangdadan/IdeaProjects/LTCODE/后端管理web端/rent-admin-web/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.25_vue@3.5.25_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60fb9093"]])

export default __exports__